import type { PartialMessages } from "../messages";

export const vi: PartialMessages = {
  "status.syncing": "Đã đồng bộ", "status.connecting": "Đang kết nối", "status.full": "Đã đầy", "status.closed": "Mất kết nối",
  "toast.connecting": "Đang kết nối…", "toast.reconnecting": "Mất kết nối. Đang thử lại…",
  "toast.retrying": "Sẽ thử lại trong giây lát.", "toast.busy": "Hiện đang đông",
  "notice.mapChanged": "{name} đã đổi bản đồ",
  "hint.place": "Nhấp để đặt, kéo để chỉ hướng (Esc để hủy)",
  "kind.objective": "Mục tiêu", "kind.rally": "Điểm tập hợp", "kind.enemy": "Địch", "kind.loot": "Đồ",
  "kind.extract": "Điểm thoát", "kind.danger": "Nguy hiểm", "kind.self": "Tôi", "kind.ping": "Chỗ này!",
  "hint.objective": "Sẽ đi đâu", "hint.rally": "Nơi tập hợp",
  "hint.enemy": "Xoay về hướng bạn nhìn thấy", "hint.loot": "Thùng hiếm, xác",
  "hint.extract": "Điểm thoát dự định", "hint.danger": "Mìn, bắn tỉa, khu trống",
  "hint.self": "Vị trí của bạn. Đặt lại sẽ xóa cái cũ",
  "hint.ping": "Dấu tạm thời, tự mất sau 25 giây",
  "tool.clearMine": "Xóa của tôi", "tool.clearMineHint": "Xóa mọi dấu bạn đã đặt",
  "sidebar.map": "Bản đồ (cho tất cả)", "sidebar.styleSvg": "Vẽ tay", "sidebar.styleTile": "Vệ tinh",
  "sidebar.floors": "Tầng (chỉ đổi hiển thị của bạn)", "sidebar.groundFloor": "Mặt đất",
  "sidebar.floorNote": "Dấu ở tầng khác sẽ hiển thị mờ.",
  "sidebar.members": "{count} người", "sidebar.you": "bạn", "sidebar.guest": "khách",
  "sidebar.clearAll": "Xóa tất cả dấu", "sidebar.openWindow": "Mở ở cửa sổ riêng (chỉ mình tôi)",
  "sidebar.invite": "Mời người khác", "sidebar.help": "Cách dùng", "sidebar.feedback": "Gửi góp ý",
  "sidebar.mapData": "Dữ liệu bản đồ", "sidebar.license": "Giấy phép", "sidebar.licenseNote": "chỉ dùng phi thương mại",
  "sidebar.room": "Phòng",
  "pin.facing": "Hướng", "pin.floor": "Tầng", "pin.map": "Bản đồ", "pin.noFacing": "Không có hướng",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "Ghi chú (ví dụ: cửa sổ tầng ba)",
  "pin.removeMine": "Xóa dấu này", "pin.removeOther": "Xóa dấu của người khác", "pin.close": "Đóng",
  "compass.n": "B", "compass.ne": "ĐB", "compass.e": "Đ", "compass.se": "ĐN",
  "compass.s": "N", "compass.sw": "TN", "compass.w": "T", "compass.nw": "TB",
  "handoff.title": "Mở ở cửa sổ riêng",
  "handoff.lede": "Liên kết dành cho chính bạn. Nó mở cùng một phòng trong trình duyệt, để Discord vẫn hiện màn hình chia sẻ còn bản đồ nằm ở màn hình khác.",
  "handoff.open": "Mở trong trình duyệt của máy này", "handoff.or": "Trên thiết bị khác",
  "handoff.codeHint": "Trên thiết bị đó, vào {host}/j/ rồi nhập mã ở trên.",
  "handoff.copy": "Sao chép liên kết", "handoff.copied": "Đã sao chép",
  "handoff.copyFailed": "Đã bôi đen ở trên — nhấn Ctrl+C",
  "handoff.expiry": "Liên kết này dùng được một lần. Hết hạn sau {time}.",
  "handoff.warn": "Không đưa cho người khác được (mở là dùng hết). Muốn gọi người thì dùng «Mời người khác».",
  "handoff.creating": "Đang tạo liên kết…", "handoff.failed": "Không tạo được liên kết",
  "invite.title": "Mời người khác",
  "invite.lede": "Gọi người không có trong kênh thoại vào bản đồ. Họ nhập tên rồi có thể đặt dấu.",
  "invite.copy": "Sao chép liên kết", "invite.warn": "Ai có liên kết này đều vào được. Đừng đăng nơi công khai.",
  "invite.budget": "Còn {left} người nữa, hết hạn sau {time} (đã dùng {used}/{max}).",
  "invite.revoke": "Hủy liên kết ngay", "invite.revoked": "Đã hủy liên kết.",
  "invite.creating": "Đang tạo liên kết…", "invite.failed": "Không tạo được liên kết",
  "invite.revokeFailed": "Không hủy được",
  "join.title": "Vào bản đồ",
  "join.lede": "Bạn được mời vào bản đồ của một trận raid. Chọn tên hiển thị — tên này sẽ nằm trên các dấu bạn đặt.",
  "join.name": "Tên", "join.go": "Vào", "join.joining": "Đang vào…", "join.failed": "Không vào được",
  "feedback.title": "Gửi cho tác giả", "feedback.request": "Đề xuất", "feedback.bug": "Lỗi",
  "feedback.other": "Khác", "feedback.requestHint": "Nếu được thế này thì hay",
  "feedback.bugHint": "Có gì đó không ổn", "feedback.otherHint": "Gì cũng được",
  "feedback.placeholder": "ví dụ: muốn kẻ đường chứ không chỉ mũi tên / ở Streets không đổi được tầng",
  "feedback.note": "Tên hiển thị Discord và ID của bạn được gửi kèm để có thể trả lời.",
  "feedback.send": "Gửi", "feedback.sending": "Đang gửi…", "feedback.sent": "Đã gửi. Cảm ơn bạn!",
  "feedback.failed": "Không gửi được",
  "time.minutes": "{n} phút", "time.hoursMinutes": "{h} giờ {m} phút",
  "error.roomFull": "Phòng này đã đầy",
  "error.tooManyWindows": "Mở quá nhiều cửa sổ cho phòng này. Hãy đóng bớt một cái.",
  "error.serverFull": "Máy chủ đã đầy", "error.session": "Phiên không còn hiệu lực. Hãy mở lại.",
  "error.handoffSpent": "Liên kết này không dùng được. Nó chỉ dùng một lần và dành cho người tạo ra nó. Muốn gọi ai đó, hãy tạo liên kết mời từ bản đồ.",
  "error.inviteSpent": "Liên kết mời này không còn dùng được. Hãy xin liên kết mới.",
  "error.inviteNotOwner": "Chỉ người tạo liên kết mới hủy được",
  "error.noRoom": "Chưa chỉ định phòng", "error.needName": "Hãy nhập tên",
  "error.tooShort": "Viết thêm một chút nhé", "error.tooLong": "Dài quá",
  "error.badKind": "Phân loại không hợp lệ",
  "error.rateLimited": "Gửi quá nhiều. Hãy đợi khoảng 10 phút.",
  "error.busy": "Đang đông. Thử lại sau ít phút.",
  "error.sendFailed": "Không gửi được. Hãy thử lại sau.",
  "error.feedbackClosed": "Hiện tạm ngừng nhận góp ý",
  "error.sessionGone": "Phiên ban đầu đã kết thúc. Hãy mở lại từ hoạt động.",
  "landing.tagline1": "Chia sẻ bản đồ Tarkov",
  "landing.tagline2": "với mọi người trong cuộc gọi Discord và cùng nhau giải thích.",
  "landing.install": "Thêm vào Discord",
  "landing.installNote": "Miễn phí. Mở bằng biểu tượng tên lửa trong kênh thoại.",
  "landing.body": "Mọi người trong cuộc gọi thấy cùng một bản đồ. Nhấp để đặt dấu, vừa đặt vừa kéo thì có thêm mũi tên chỉ hướng — chỉ được cả «ở đâu» lẫn «đi hướng nào».",
  "landing.point1": "Chỉ cần ở cùng cuộc gọi. Không phải nhập mã",
  "landing.point2": "Đủ 13 bản đồ. Vẽ tay hoặc vệ tinh, và có tầng",
  "landing.point3": "Dấu vẫn nằm đó, lát nữa xem lại được",
  "landing.point4": "Người không ở trong cuộc gọi vào bằng liên kết mời",
  "landing.footNote": "Hoàn toàn không đụng tới game. Không đọc tệp, không đọc bộ nhớ, không vẽ gì lên màn hình game. Mọi dấu đều do người đặt bằng tay.",
  "landing.footCredit": "Dự án cá nhân, chạy miễn phí. Dữ liệu bản đồ từ {tarkovdev} (CC BY-NC-SA 4.0). Escape from Tarkov là sản phẩm của Battlestate Games Limited; đây là dự án fan không chính thức, không liên quan tới họ.",
  "landing.updates": "Cập nhật", "landing.allUpdates": "Tất cả cập nhật",
  "boot.connecting": "Đang kết nối tới Discord…", "boot.failedTitle": "Không khởi động được",
};
